// noinspection DuplicatedCode

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import { useMutation } from "@tanstack/react-query";
import { fetchPost, fetchPostSilance, fetchGet } from "../../../fetchers";
import { toast } from "react-toastify";
import { Card } from "@material-tailwind/react";
import { HrdInputGenerator } from "../../../components/form/HrdInputGenerator";

import DatePicker from "react-datepicker";
import readXlsxFile from "read-excel-file";

import "react-datepicker/dist/react-datepicker.css";

// import { alertService } from "../../../../services/AlertService";

// import Loading from "../../../../components/loading/Loading";
import TableKaryawanPayrollDetail from "../../../components/tablecard/TablePayroll";

import { Colors } from "../../../assets/Colors";
import { isRequired, useForm } from "../../../components/isRequired";
import {
  getMinTipeKaryawan,
  tipeKaryawanSelector,
} from "../../../features/master/tipe-karyawan/tipeKaryawanSlice";

const PayrollPageRekap = ({}) => {
  let initialState = {
    Bulan: new Date(),
  };
  const paramsUrl = useParams();
  const dispatch = useDispatch();
  const mutation = useMutation((param) =>
    fetchGet("getKaryawanPayrollRekap", param)
  );
  const mutationInsert = useMutation((param) =>
    fetchPost("InsertRekapKaryawan", param)
  );
  const mutationDelete = useMutation((param) =>
    fetchPost("DeleteRekapKaryawan", param)
  );
  const mutationImport = useMutation((param) =>
    fetchPost("ImportExcelRekapAtt", param)
  );

  const validations = [];
  const [showSave, setshowSave] = useState(false);
  const [importValue, setimportValue] = useState({
    Bulan: (new Date().getMonth() + 1).toString(),
    Tahun: new Date().getFullYear().toString(),
    Data: [],
  });
  const [dataInsert, setdataInsert] = useState({
    Bulan: (new Date().getMonth() + 1).toString(),
    Data: [],
  });
  const [param, setParam] = useState({
    Bulan: (new Date().getMonth() + 1).toString(),
    Tahun: new Date().getFullYear().toString(),
    Region: "L0002",
    TipeKaryawan: "",
  });

  const [searchTipeKaryawanValue, setsearchTipeKaryawanValue] =
    React.useState("");

  const tipeKaryawan = useSelector(tipeKaryawanSelector);

  const {
    changed,
    values,
    isValid,
    errors,
    touched,
    changeHandler,
    editHandler,
    clearHandler,
    submitHandler,
    customHandler,
  } = useForm(initialState, validations);

  useEffect(() => {
    mutation.mutate(param);
  }, [param]);
  useEffect(() => {
    if (mutation.data !== undefined && Array.isArray(mutation.data.data)) {
      setshowSave(true);
      setdataInsert({
        Bulan: isNaN((new Date(values.Bulan).getMonth() + 1).toString())
          ? (new Date().getMonth() + 1).toString()
          : (new Date(values.Bulan).getMonth() + 1).toString(),
        Tahun: isNaN(new Date(values.Bulan).getFullYear().toString())
          ? new Date().getFullYear().toString()
          : new Date(values.Bulan).getFullYear().toString(),
        Data: mutation.data.data,
      });
    } else {
      setshowSave(false);
    }
  }, [mutation.data]);
  useEffect(() => {
    if (mutationDelete.isSuccess) {
      window.location.reload(false);
    }
  }, [mutationDelete]);

  const filterApi = () => {
    setParam({
      Bulan: isNaN((new Date(values.Bulan).getMonth() + 1).toString())
        ? (new Date().getMonth() + 1).toString()
        : (new Date(values.Bulan).getMonth() + 1).toString(),
      Tahun: isNaN(new Date(values.Bulan).getFullYear().toString())
        ? new Date().getFullYear().toString()
        : new Date(values.Bulan).getFullYear().toString(),
      Region: values.Region,
      TipeKaryawan: values.tipeKaryawan,
    });
  };

  const changeFileExcel = (e) => {
    readXlsxFile(e.target.files[0])
      .then((rows) => {
        if (rows[0][0] == `BPJSKS`) {
          rows.splice(0, 1);
          setimportValue({
            Data: rows,
            Bulan: isNaN((new Date(values.Bulan).getMonth() + 1).toString())
              ? (new Date().getMonth() + 1).toString()
              : (new Date(values.Bulan).getMonth() + 1).toString(),
            Tahun: isNaN(new Date(values.Bulan).getFullYear().toString())
              ? new Date().getFullYear().toString()
              : new Date(values.Bulan).getFullYear().toString(),
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const ImportExcel = (e) => {
    mutationImport.mutate(importValue);
  };

  const InsertRekap = () => {
    mutationInsert.mutate(dataInsert);
  };
  const DeleteRekap = () => {
    mutationDelete.mutate(dataInsert);
  };

  return (
    <>
      <div className="md:ml-64">
        <div
          style={{ background: Colors.primary }}
          className="pt-14 pb-16 px-3 md:px-8 h-auto"
        >
          <div className="container mx-auto max-w-full">
            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
          </div>
        </div>

        <div className="px-3 md:px-8 h-auto -mt-32">
          <div className="container mx-auto max-w-full">
            <Card>
              <div className="flex flex-row flex-wrap items-start justify-start w-full px-2 py-2">
                <div className={"w-1/4"}>
                  <HrdInputGenerator
                    type={"bulan"}
                    name={"Bulan"}
                    title={"Bulan"}
                    value={values}
                    required={true}
                    onChange={customHandler}
                    touched={touched}
                    errors={errors}
                    size={"full"}
                  />
                </div>
                <div className={"w-1/4"}>
                  <HrdInputGenerator
                    type={"region"}
                    name={"Region"}
                    title={"Region"}
                    value={values}
                    required={true}
                    onChange={customHandler}
                    touched={touched}
                    errors={errors}
                    size={"full"}
                  />
                </div>
                <div className={"w-1/4 pt-4"} style={{ paddingTop: "24px" }}>
                  <div class="w-full px-3 mb-6">
                    <select
                      value={searchTipeKaryawanValue}
                      onChange={(e) => {
                        setsearchTipeKaryawanValue(e.target.value);
                        customHandler(e.target.value, "tipeKaryawan");
                      }}
                      name="TipeKaryawanID"
                      // className=" appearance-none w-full bg-white border hover:border-gray-800 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                      className={
                        " appearance-none w-full  text-gray-700 border border-gray-500 rounded py-2 px-3 leading-tight outline-none bg-white"
                      }
                      onClick={() => {
                        dispatch(getMinTipeKaryawan({ search: "" }));
                      }}
                    >
                      <option defaultValue disabled value="" hidden>
                        -- Pilih Data --
                      </option>
                      {tipeKaryawan.minData.map((item, i) => (
                        <option
                          key={item.TipeKaryawanID}
                          value={item.NamaTipeKaryawan}
                        >
                          {item.NamaTipeKaryawan}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className={"w-1/4"}>
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Buka data
                  </label>

                  <button
                    type="button"
                    onClick={filterApi}
                    className=" text-main-100 hover:text-white border border-main-100 hover:bg-main-100 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2 text-center mr-2 mb-2 "
                  >
                    Buka
                  </button>
                </div>
                {showSave ? (
                  <div className={"w-1/4"}>
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Save Rekap
                    </label>

                    <button
                      type="button"
                      onClick={InsertRekap}
                      className=" text-main-100 hover:text-white border border-main-100 hover:bg-main-100 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2 text-center mr-2 mb-2 "
                    >
                      Save
                    </button>
                  </div>
                ) : (
                  ""
                )}
                {showSave ? (
                  <div className={"w-1/4"}>
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Delete Rekap
                    </label>

                    <button
                      type="button"
                      onClick={DeleteRekap}
                      className=" text-main-100 hover:text-white border border-main-100 hover:bg-main-100 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2 text-center mr-2 mb-2 "
                    >
                      Delete
                    </button>
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className="flex flex-row flex-wrap items-start justify-start w-full px-2 py-2">
                <div className={"w-1/4 pl-2"}>
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Upload Data PHKT
                  </label>

                  <label
                    htmlFor={"NamaFile"}
                    // className="block w-full border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"

                    className="py-3 px-4 rounded block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 border border-gray-200"
                  >
                    {values["NamaFile"] ? (
                      <span>
                        File Selected -{" "}
                        {values["NamaFile"].name
                          ? values["NamaFile"].name
                          : values["NamaFile"]}
                      </span>
                    ) : (
                      <span>Choose a file...</span>
                    )}
                  </label>

                  <input
                    type="file"
                    id={"NamaFile"}
                    key={"NamaFile"}
                    name={"NamaFile"}
                    style={{ visibility: "hidden" }}
                    className=""
                    onChange={(e) => {
                      changeFileExcel(e);
                      customHandler(e.target.files[0], "NamaFile");
                    }}
                  />
                </div>

                <div className={"w-1/4 pl-2 py-6"}>
                  <button
                    type="button"
                    onClick={ImportExcel}
                    className="text-main-100 hover:text-white border border-main-100 hover:bg-main-100 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2 text-center mr-2 mb-2 "
                  >
                    Import
                  </button>
                </div>
              </div>

              <div className="flex flex-col items-center content-center ">
                <TableKaryawanPayrollDetail
                  usingMutation={true}
                  mutation={mutation}
                  param={param}
                  primaryID="ID"
                  transaksi={true}
                  tableData={mutation.data}
                  handleSearch={() => {}}
                  searchPlaceholder=""
                />
              </div>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
};

export default PayrollPageRekap;
